import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {BehaviorSubject} from "rxjs";
import {environment} from "../../environments/environment";

export interface Maintenance {
	start: Date,
	end: Date,
	messageDE: string,
	messageEN: string,
	lockPage: boolean,
	id: string
	updatedAt: Date,
	createdAt: Date
}

export interface MaintenancesDTO {
	rows: Array<Maintenance>,
	count: number
}

@Injectable({
	providedIn: 'root'
})
export class MaintenanceService {
	private _maintenances$: BehaviorSubject<Array<Maintenance>> = new BehaviorSubject<Array<Maintenance>>([]);
	private _nextMaintenance$: BehaviorSubject<Maintenance> = new BehaviorSubject<Maintenance>(null);
	private _paginator = {
		paginator: {
			page: 1,
			pageSize: 10
		}
	}

	constructor(
		private httpClient: HttpClient
	) { }

	get nextMaintenance$() {
		return this._nextMaintenance$.asObservable();
	}

	get maintenances$() {
		return this._maintenances$.asObservable();
	}

	loadNextMaintenance() {
		let url = environment.API_ENDPOINT + environment.VERSION_V1 + environment.API_ROUTES.CORE.MAINTENANCE.NEXT;
		this.httpClient.get<Maintenance>(url).subscribe({
			next: value => this._nextMaintenance$.next(value),
			error: err => console.error(err)
		});
	}

	loadMaintenances() {
		const url = environment.API_ENDPOINT + environment.VERSION_V1 + environment.API_ROUTES.CORE.MAINTENANCE.SEARCH;
		this.httpClient.post<MaintenancesDTO>(url, this._paginator).subscribe({
			next: value => this._maintenances$.next(value.rows),
			error: err => console.error(err)
		});
	}
}
